import React, { useState } from "react";

const ProgramModulesEJ = () => {
  const [openSectionIndex, setOpenSectionIndex] = useState(null);

  const toggleSectionDetails = (index) => {
    setOpenSectionIndex((prev) => (prev === index ? null : index));
  };

  const sections = [
    {
      title: "Advanced News Writing and Reporting (5 ECTS)",
      description: [
        "Master the art of writing compelling news articles and reports, focusing on clarity, accuracy, and narrative impact.",
      ],
    },
    {
      title: "Investigative Journalism Techniques (5 ECTS)",
      description: [
        "Develop advanced skills in research, source verification, and ethical reporting to uncover hidden stories and issues.",
      ],
    },
    {
      title: "Multimedia Storytelling for the Digital Age (5 ECTS)",
      description: [
        "Learn to integrate visuals, audio, and interactive elements into stories, creating impactful multimedia content for diverse audiences.",
      ],
    },
    {
      title: "Ethics and Media Law in Journalism (5 ECTS)",
      description: [
        "Examine the legal and ethical frameworks governing journalism, ensuring responsible and credible reporting practices.",
      ],
    },
    {
      title: "Emerging Trends in Global Media (5 ECTS)",
      description: [
        "Explore the latest trends, technologies, and innovations shaping journalism and the media industry on a global scale.",
      ],
    },
    {
      title: "Collaborative Journalism Project (5 ECTS)",
      description: [
        "Apply learned skills in a real-world collaborative project, producing a multimedia journalistic piece addressing a contemporary issue.",
      ],
    },
  ];

  return (
    <div>
      <section
        id="program-modules-ep"
        className="p-3 scroll-m-14 md:scroll-mt-44 z-[4]"
      >
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-center pb-5">
            <p className="border-b-4 border-sdorange inline-block text-center text-2xl font-bold">
              Programme Modules
            </p>
          </div>

          <div className="px-5">
            {sections.map((section, index) => (
              <div
                key={index}
                className="border-2 rounded-md bg-gray-400 bg-opacity-50 border-sdorange p-4 w-full mb-6 cursor-pointer hover:bg-gray-300"
                onClick={() => toggleSectionDetails(index)}
              >
                <div className="flex justify-between items-center">
                  <div className="flex items-center space-x-2">
                    <img
                      src="/image-fix/academic-programmes/certified-courses/icons/play-circle-svgrepo-com.svg"
                      alt="Play Icon"
                      className="h-6 w-6"
                    />
                    <h3 className="text-xl font-semibold">{section.title}</h3>
                  </div>
                  <div>
                    {openSectionIndex === index ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-gray-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 15l7-7 7 7"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-gray-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    )}
                  </div>
                </div>

                {openSectionIndex === index && (
                  <div className="mt-3 p-2 bg-sdbodywhiteywhitebodyywhitebody rounded shadow">
                    <ul className="list-disc pl-5">
                      {section.description.map((desc, idx) => (
                        <li key={idx} className="text-sm text-gray-600 mb-2">
                          {desc}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProgramModulesEJ;
